import {
  model,
  Model,
  prop,
  _async,
  _await,
  idProp,
  registerRootStore,
  modelAction,
  modelFlow,
  Frozen,
  frozen,
} from "mobx-keystone";
import { computed, observable } from "mobx";
import { createContext } from "react";
import { sendToRailsController } from "../helpers/requests";
import { startAccountsActionCable } from "../helpers/actionCable";

@model("exrails/Rizvoice")
export class Rizvoice extends Model({
  _version: prop(0),
  id: idProp,
  accountUUid: prop<string>(""),
  mustMakeInvoicePaymentBeforeClaimingCubby: prop<boolean>(true),
  paywallPayRequest: prop<string>(""),
  hasLoaded: prop<boolean>(false),
  useUsdForFiat: prop<boolean>(true),
  environmentData: prop<Frozen<any> | undefined>(),
  cubbyData: prop<Frozen<any> | undefined>(),
  shouldOfferSubscription: prop<boolean>(false),
  subscriptionPlans: prop<Frozen<[]> | undefined>(),
  subscriptionPaymentPayRequest: prop<string>(""),
}) {
  @observable
  subscriptionPaymentJustPaid = false;

  @modelAction
  handleSubscriptionPaymentJustPaid = () => {
    this.subscriptionPaymentJustPaid = true;
  };

  @modelAction
  setSubscriptionPaymentPayRequest(subscriptionPaymentPayRequest: string) {
    this.subscriptionPaymentPayRequest = subscriptionPaymentPayRequest;
  }

  @modelAction
  setMustMakeInvoicePaymentBeforeClaimingCubby(
    mustMakeInvoicePaymentBeforeClaimingCubby: boolean
  ) {
    this.mustMakeInvoicePaymentBeforeClaimingCubby =
      mustMakeInvoicePaymentBeforeClaimingCubby;
  }

  @modelAction
  setPaywallPayRequest(paywallPayRequest: string) {
    this.paywallPayRequest = paywallPayRequest;
  }

  @modelAction
  setToHasLoaded() {
    this.hasLoaded = true;
  }

  @modelAction
  hydrateDataFromPage() {
    const rootDiv = document.getElementById("root");
    const json = JSON.parse(rootDiv.dataset.hydrate);
    console.log("hydrating rizvoice data from page", json);
    this.accountUUid = json.account.accountUuid;
    this.useUsdForFiat = json.account.use_usd_for_fiat;
    this.environmentData = frozen(json.environment);
    this.mustMakeInvoicePaymentBeforeClaimingCubby =
      json.account.mustMakeInvoicePaymentBeforeClaimingCubby;
    this.cubbyData = frozen(json.cubby);
    this.shouldOfferSubscription = json.shouldOfferSubscription;
    this.subscriptionPlans = frozen(json.subscriptionPlans);
    startAccountsActionCable(null, this);
    // race conditiong with generating paywall invoice
    // do this after action cable connects intead
    //this.hasLoaded = true;
  }

  @modelFlow
  rizLife = _async(function* (
    this: Rizvoice,
    directive: string,
    data: any = {}
  ) {
    const message = {
      accountUuid: this.accountUUid,
      directive: directive,
      data: data,
    };
    sendToRailsController(message, "/rizvoice_life/rizvoice_life")
      .then((response) => {
        //console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  });
}

export const runCreateRizvoice = () => {
  const rizvoice = new Rizvoice({
    hasLoaded: false,
    environmentData: frozen({}),
    cubbyData: frozen({}),
    subscriptionPlans: frozen([]),
  });

  registerRootStore(rizvoice);
  return rizvoice;
};

const createdRizvoice = runCreateRizvoice();
//console.log("created workspace", getSnapshot(createdWorkspace));
export const RizvoiceContext = createContext<Rizvoice>(createdRizvoice);

export interface RizvoiceInterface {
  Rizvoice: Rizvoice;
}
